var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.6591 17H13.9366C13.9366 14.094 11.4991 11.7307 8.50101 11.7307C5.50289 11.7307 3.06632 14.0949 3.06632 17H1.34375C1.34375 13.1432 4.55547 10.0081 8.50187 10.0081C12.4474 10.0081 15.6591 13.1432 15.6591 17Z","fill":"#04B3C0","key":0}),React.createElement("path",{"d":"M8.50257 9.44827C5.89891 9.44827 3.7793 7.32779 3.7793 4.72414C3.77844 2.11962 5.89805 0 8.50257 0C11.108 0 13.2276 2.11876 13.2276 4.72414C13.2276 7.32952 11.108 9.44827 8.50257 9.44827ZM8.50257 1.72257C6.84719 1.72257 5.501 3.06875 5.501 4.72414C5.501 6.37952 6.84719 7.72571 8.50257 7.72571C10.1588 7.72571 11.505 6.37952 11.505 4.72414C11.505 3.06875 10.1571 1.72257 8.50257 1.72257Z","fill":"#04B3C0","key":1})]);
}

User.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = User;

User.default = User;
